export default class SelectionUpdater {
    constructor(lockTable, selection, veilText, selectionVeil) {
        this.lockTable = lockTable;
        this.selection = selection;
        this.veilText = veilText;
        this.selectionVeil = selectionVeil;

        if (lockTable)
            this.runnerController = lockTable.getRunnerController();
    }

    beforeRpcCall() {
        this.selectionVeil.showOver(this.selection, this.veilText);
        this.lockTable.setIgnoreUserActivity(true);
    }

    afterRpcCall(success) {
        if (!success)
            this.onUpdateComplete();
    }

    handleRpcCallResult(result) {
        this.handleResult(result);
        this.onUpdateComplete();
    }

    onUpdateComplete() {
        this.selectionVeil.hide();
        this.lockTable.clearSelection();
        this.lockTable.setIgnoreUserActivity(false);
    }

    handleResult(result) {
        //depends on perfoming action (lock/unlock)
        //implemented in inheritors
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/SelectionUpdater.js